import {
    ComposedChart, Area, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend
} from 'recharts';
import commonArray from './common/commonArray';
const Graph = (props: any) => {
    // Determine the correct x-axis data key based on the current view
    const dayOrder = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    const monthOrder = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    const getXAxisDataKey = () => {
        if (props.Match === 'DAILY') return 'hour';
        if (props.Match === 'WEEKLY') return 'day';
        if (props.Match === 'MONTHLY') return 'date';
        if (props.Match === 'YEARLY') return 'month';
        return props.xAxis || 'hour'; 
    };

    const getYAxisDataKey = () => {
        if (props.run === 'product') return 'total_products';
        if (props.run === 'sales') return 'total_orders';
        return props.yAxis || 'total_products'; 
    };

    const xAxisDataKey = getXAxisDataKey();
    const yAxisDataKey = getYAxisDataKey();

    const sortedData = [...(props.data || [])].sort((a, b) => {
        if (props.Match === 'WEEKLY') {
            return dayOrder.indexOf(a.day) - dayOrder.indexOf(b.day);
        }
        if (props.Match === 'YEARLY') {
            return monthOrder.indexOf(a.month) - monthOrder.indexOf(b.month);
        }
        if (props.Match === 'DAILY') {
            return parseInt(a.hour) - parseInt(b.hour);
        }
        if (props.Match === 'MONTHLY') {
            return parseInt(a.date) - parseInt(b.date);
        }
        return 0;
    });

    return <div className="col-xl-6 px-0 px-md-2">
        <div className="common-card">
            <div className="common-card-title d-flex justify-content-between align-items-center flex-column flex-md-row">
                <h5 className='text-nowrap mb-2 mb-md-0'>{props.heading}</h5>
                <div className="btn-group">
                    {commonArray.buttonArray.map((res,index:number) => <button className={`btn btn-white ${props.Match === res.toUpperCase() ? 'active-btn' : ''}`} type="button" onClick={() => props.dashboadGraph(props.run, res.toUpperCase())} disabled={props.loading} key={index}>{res}</button>)}
                </div>
            </div>
            <div className="common-card-content">
                <ResponsiveContainer width={'100%'} height={300}>
                    <ComposedChart width={600} height={300} data={sortedData}>
                        <XAxis dataKey={xAxisDataKey} stroke="#2f4050" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Area type="monotone" dataKey={yAxisDataKey} fill="#8928a73d" stroke="#2f4050" />
                        {/* <Bar dataKey={yAxisDataKey} barSize={50} fill="#9900CD" /> */}
                    </ComposedChart>
                </ResponsiveContainer>
            </div>
        </div>
    </div>

}
export default Graph;
